/**
 * Build an absolute URL for the current origin + path (e.g. `/mint-space/abc`).
 */
export function getShareUrl(path) {
  if (typeof window === "undefined") return "";
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${window.location.origin}${p}`;
}

/**
 * Use Web Share API when available; otherwise copy to clipboard and toast.
 */
export async function shareOrCopyUrl(url, setToast, t) {
  const copied = () =>
    setToast?.(t?.("common.linkCopied") || "Link copied to clipboard");
  const failed = () => setToast?.(t?.("common.copyFailed") || "Could not copy link");

  try {
    if (typeof navigator !== "undefined" && navigator.share) {
      await navigator.share({ url });
      return;
    }
  } catch (e) {
    if (e?.name === "AbortError") return;
  }

  try {
    await navigator.clipboard.writeText(url);
    copied();
  } catch {
    failed();
  }
}
